import { Radio, Tooltip } from 'antd'
import type { EncounterLabApiItem } from 'features/Procedure/state/procedure-api.type'
import { memo, useCallback } from 'react'
import styles from './lab-select.module.scss'

type Props = {
  lab: EncounterLabApiItem
  selectedLabId: number | null
  onSelect: (lab: EncounterLabApiItem) => void
}

const LabSelectComponent = ({ lab, selectedLabId, onSelect }: Props) => {
  const handleChange = useCallback(() => {
    onSelect(lab)
  }, [onSelect, lab])

  return (
    <button className={styles.container} onClick={handleChange}>
      <Radio
        value={lab.id}
        className='center'
        checked={selectedLabId === lab.id}
        onChange={handleChange}
      />
      <Tooltip title={lab.filename || ''} placement='right'>
        <div className={styles.tooltip} onClick={handleChange}>
          {lab.filename}
        </div>
      </Tooltip>
    </button>
  )
}

export const LabSelect = memo(LabSelectComponent, (prevProps, nextProps) => {
  return (
    prevProps.lab.id === nextProps.lab.id && prevProps.selectedLabId === nextProps.selectedLabId
  )
})
